module.exports = __webpack_public_path__ + "static/media/58.e5d36e7.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/58.wav
// module id = hMq/
// module chunks = 0